import React from "react";
import { LinkedinOutlined, TwitterOutlined, WhatsAppOutlined } from "@ant-design/icons";

interface SocialShareProps {
  url: string;
  title: string;
}

const SocialShare: React.FC<SocialShareProps> = ({ url, title }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  return (
    <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
      <span style={{ fontWeight: 600, fontSize: 13, color: "#555", alignSelf: "center" }}>Share this role:</span>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        target="_blank"
        rel="noreferrer"
        className="btn btn-sm btn-outline-primary"
        style={{ borderRadius: "50%", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}
      >
        <LinkedinOutlined />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
        target="_blank"
        rel="noreferrer"
        className="btn btn-sm btn-outline-info"
        style={{ borderRadius: "50%", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", padding: 0, color: "#1da1f2", borderColor: "#1da1f2" }}
      >
        <TwitterOutlined />
      </a>
      <a
        href={`https://api.whatsapp.com/send?text=${encodedTitle} ${encodedUrl}`}
        target="_blank"
        rel="noreferrer"
        className="btn btn-sm btn-outline-success"
        style={{ borderRadius: "50%", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}
      >
        <WhatsAppOutlined />
      </a>
    </div>
  );
};

export default SocialShare;
